import { render, staticRenderFns } from "./SidebarSharePlugin.vue?vue&type=template&id=466fec04"
import script from "./SidebarSharePlugin.vue?vue&type=script&lang=js"
export * from "./SidebarSharePlugin.vue?vue&type=script&lang=js"
import style0 from "./SidebarSharePlugin.vue?vue&type=style&index=0&id=466fec04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports